import type { FaireProductEntity } from "../../entity_types/product";

export const atc_nf_chunks_9: FaireProductEntity = {
  token: "atc_nf_chunks_9",
  type: "product",
  name: "Baby Dolly Claw in Moonlight",
  brandName: "Chunks",
  imageUrl:
    "https://cdn.shopify.com/s/files/1/0510/2698/5143/files/MoonlightBabyDollyFlatlay_1.jpg?v=1690249312",
  priceDollars: 18.95,
  msrpDollars: 38,
  description: "ATC migration seed product",
  tags: ["hair", "accessories", "chunks"],
  freeShipping: true,
  meta: {
    source: "mock",
    importedAt: "2026-03-25T00:00:00.000Z",
    importedBy: "atc-entity-migration",
  },
};
